import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Observable } from 'rxjs';
import { PortalUserInfo } from 'src/app/feature-module/portal-users/models/PortalUserInfo';
import { PortalUserService } from 'src/app/feature-module/portal-users/services/portalUser.service';
import { ControlSettings } from 'src/app/shared/controls/ControlSettings';

@Component({
  selector: 'app-user-select-ctrl',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: UserSelectComponent,
    multi: true
  }]
})
export class UserSelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, private userService: PortalUserService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Output() valueChangeEvent = new EventEmitter<any>();
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};


  usersList$: Observable<PortalUserInfo[]>;
  filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
    fields: ['name', 'surname', 'userName']
  };
  
  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
    this.usersList$ = this.userService.getAllUsers();
  }

  onChange(value: string) {
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
